import { Link } from 'react-router';
import { House, LogOut } from 'lucide-react';

import { Avatar, AvatarFallback } from '@shared/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@shared/components/ui/dropdown-menu';

import { useUser } from '@features/user-access';

/** Avatar button of the header: user name, link to the dashboard and sign out. */
export const AccountMenu = () => {
  const { userAccess, logout } = useUser();
  const name = userAccess.name ?? '';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label="Compte"
          className="rounded-full border-0 bg-transparent p-0 outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
          type="button"
        >
          <Avatar className="size-10 ring-2 ring-primary/40 ring-offset-2 ring-offset-canvas">
            <AvatarFallback className="bg-primary/16 font-bold text-primary">
              {name.charAt(0).toUpperCase() || '?'}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="truncate text-sm font-semibold normal-case text-foreground">
          {name || 'Utilisateur'}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/">
            <House />
            Tableau de bord
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={logout} variant="destructive">
          <LogOut />
          Déconnexion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
